module.exports = __webpack_public_path__ + "img/settings-icon.2b4ceed0.svg";